var $ = jQuery;

export default class Accordion {

  ready() {

    const HASH = window.location.hash;
    const ACCORDIONS = document.querySelectorAll('.mtt-template-content__accordion-title');

    if (ACCORDIONS.length > 0) {
      for (let i = 0; i < ACCORDIONS.length; i++) {
        const ACCORDION = ACCORDIONS[i];

        ACCORDION.addEventListener('click', function (e) {
          if (this.parentElement.classList.contains('active')) {
            this.parentElement.classList.remove('active')
          } else {
            this.parentElement.classList.add('active');
          }
        });
      }
    }

    if(HASH){
      const EL = document.querySelector(HASH);
      if(EL){
        if (EL.classList.contains('active')) {
          EL.classList.remove('active')
        } else {
          EL.classList.add('active');
        }
      }
    }
  }
}